<template>
  <div>
    <GameRondoEs v-if="$i18n.locale === 'es'" />
    <GameRondoEn v-else />
  </div>
</template>

<script>
import GameRondoEs from '@/components/games/rondo/GameRondoEs.vue';
import GameRondoEn from '@/components/games/rondo/GameRondoEn.vue';

export default {
  name: 'GameRondo',
  components: {
    GameRondoEs,
    GameRondoEn,
  },
};
</script>
